/**
 * Profile Constants
 * Vrednosti moraju da prate backend:
 *   - ReportJmHelper::calculateImportance()  (1 => 0.25, 2 => 0.5, 3 => 1.0)
 *   - ReportJmigHelper::calculateImportance()
 */

export const IMPORTANCE = {
  NOT_VERY_IMPORTANT: 1,
  MODERATE_IMPORTANT: 2,
  VERY_IMPORTANT: 3,
};

export const IMPORTANCE_OPTIONS = [
  { id: 1, name: "Not very important", value: IMPORTANCE.NOT_VERY_IMPORTANT },
  { id: 2, name: "Moderate important", value: IMPORTANCE.MODERATE_IMPORTANT },
  { id: 3, name: "Very important", value: IMPORTANCE.VERY_IMPORTANT },
];

/**
 * Feature grupe koje nose upitnik iz kog se izvode kompetencije profila.
 * Mora da prati App\Service\ProfileCompetenceGenerator::COMPETENCE_FEATURE_GROUPS.
 *   1  - 180/360 Survey
 *   4  - Potential Survey
 *   10 - Task Package
 *   73 - Success Factors 2024 - Benchmark
 */
export const COMPETENCE_FEATURE_GROUPS = [1, 4, 10, 73];

export const PROFILE_TYPE = {
  FAVORABLE_ZONE_MATCH: 1,
  JOB_MATCH: 2,
};

export const PROFILE_TYPE_OPTIONS = [
  { id: PROFILE_TYPE.FAVORABLE_ZONE_MATCH, name: "Favorable Zone Match" },
  { id: PROFILE_TYPE.JOB_MATCH, name: "Job Match" },
];

export function importanceLabel(value) {
  const option = IMPORTANCE_OPTIONS.find((item) => item.value === value);
  return option ? option.name : "";
}

export function profileTypeLabel(value) {
  const option = PROFILE_TYPE_OPTIONS.find((item) => item.id === value);
  return option ? option.name : "";
}
